import lazyScreen from './utils/lazyScreen';
import Modules_Setting from './routes/setting';
import Modules_User from './routes/user';
import Modules_Office from './routes/of';
import Modules_WF from './routes/wf';
import Modules_CA from './routes/ca';
import Modules_AP from './routes/ap';
import Modules_AR from './routes/ar';
import Modules_Serve from './routes/serve';
import Modules_Event from './routes/event';
import Modules_Travel from './routes/travel';
import Modules_Rental from './routes/rental';
import Modules_CRM from './routes/crm';
import Modules_Wallet from './routes/wallet';
import Modules_VRM from './routes/vrm';
import Modules_COMS from './routes/coms';
import Modules_Loyalty from './routes/loyalty';
import Modules_PM from './routes/pm';
import Modules_INV from './routes/inv';
import Modules_SPC from './routes/spc';
import Modules_LG from './routes/lg';
import Modules_Carrier from './routes/carrier';
import Modules_Food from './routes/food';
import Modules_EXP from './routes/exp';
import Modules_EXR from './routes/exr';
import Modules_HRM from './routes/hrm';
import Modules_Timesheet from './routes/timesheet';
import Modules_Payroll from './routes/payroll';
import Modules_TAX from './routes/tax';
import Modules_PNL from './routes/pnl';
import Modules_GL from './routes/gl';
import Modules_ACC from './routes/acc';
import Modules_FA from './routes/fa';
import Modules_MF from './routes/mf';
import Modules_RPT from './routes/rpt';
import Modules_Deploy from './routes/deploy';
import Modules_Deployment from './routes/deployment';
import Modules_B2B from './routes/b2b';
import Modules_SaleChannel from './routes/saleChannel';
import Modules_Marketing from './routes/marketing';
import Modules_SocialChannel from './routes/socialChannel';
import Modules_Integration from './routes/integration';
import Modules_AI from './routes/ai';
import Modules_Media from './routes/media';
// import Modules_ASM from './routes/asm';





















// import HomePage from './pages/home/home';
const DashboardPage = lazyScreen(() => import('./pages/home/DashboardPage.js'), 'pages/home/DashboardPage.js');
const ModuleHomePage = lazyScreen(() => import('./pages/home/ModuleHomePage.js'), 'pages/home/ModuleHomePage.js');

const HRWorkingAttendance = lazyScreen(() => import('./screens/HRWorkingAttendance/index.js'), 'screens/HRWorkingAttendance/index.js');
const AROrderBilling = lazyScreen(() => import('./screens/AROrderBilling/index.js'), 'screens/AROrderBilling/index.js');

export default [
    // {
    //     path: '/home',
    //     component: HomePage
    // },
    {
        path: '/dashboard/:key',
        component: DashboardPage
    },
    {
        path: '/module/:moduleKey',
        component: ModuleHomePage
    },
    ...Modules_Setting,
    ...Modules_User,
    ...Modules_Office,
    ...Modules_WF,
    ...Modules_CA,
    ...Modules_AP,
    ...Modules_AR,
    ...Modules_Serve,
    ...Modules_Event,
    ...Modules_Travel,
    ...Modules_Rental,
    ...Modules_CRM,
    ...Modules_Wallet,
    ...Modules_VRM,
    ...Modules_COMS,
    ...Modules_Loyalty,
    ...Modules_PM,
    ...Modules_INV,
    ...Modules_SPC,
    ...Modules_LG,
    ...Modules_Carrier,
    ...Modules_Food,
    // ...Modules_ASM,
    ...Modules_EXP,
    ...Modules_EXR,
    ...Modules_HRM,
    ...Modules_Timesheet,
    ...Modules_Payroll,
    ...Modules_TAX,
    ...Modules_PNL,
    ...Modules_GL,
    ...Modules_ACC,
    ...Modules_FA,
    ...Modules_MF,
    ...Modules_RPT,
    {
        path: '/pos/HRWorkingAttendance',
        component: HRWorkingAttendance
    },
    {
        path: '/pos/AROrderBilling',
        component: AROrderBilling
    },
    ...Modules_Deploy,
    ...Modules_Deployment,

    ...Modules_B2B,

    ...Modules_SaleChannel,
    ...Modules_Marketing,

    ...Modules_SocialChannel,

    ...Modules_Integration,

    ...Modules_AI,

    ...Modules_Media
];
